import { combineReducers } from 'redux';

import carHireIndicativePricing, * as fromCarHireIndicativePricing from './carHireIndicativePricing';
import carhire, * as fromCarHire from './carhire';
import exploreAccommodations, * as fromExploreAccommodations from './exploreAccommodations';
import hotelIndicativePricing, * as fromHotelIndicativePricing from './hotelIndicativePricing';
import hotels, * as fromMichelinHotels from './hotels';
import packages, * as fromPackages from './packages';
import packagesRealTimeSavings, * as fromPackagesRealTimeSavings from './packagesRealTimeSavings';
import pollingSession, * as fromPollingSession from './pollingSession';
import verticals from './verticals';

import type { CarHireIndicativePricingState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/michelin/carHireIndicativePricing';
import type { HotelIndicativePricingState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/michelin/hotelIndicativePricing';
import type { MichelinHotelsState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/michelin/hotels';
import type {
  PollingSessionState,
  MichelinState,
} from '@web-platform/shared-universal-types/src/redux/banana/state/shared/michelin/michelin';
import type { VerticalsState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/michelin/verticals';
import type { PackagesState } from '@web-platform/shared-universal-types/src/redux/state/shared/michelin/packages';
import type { PackagesRealTimeSavingsState } from '@web-platform/shared-universal-types/src/redux/state/shared/michelin/packagesRealTimeSavings';
import type { Reducer } from 'redux';

export default combineReducers({
  carhire,
  hotels,
  packages,
  packagesRealTimeSavings,
  pollingSession,
  verticals,
  hotelIndicativePricing,
  carHireIndicativePricing,
  exploreAccommodations,
}) as Reducer<MichelinState>;

export const getVerticals = (state: MichelinState): VerticalsState => state.verticals;
export const getPollingState = (state: MichelinState): PollingSessionState =>
  fromPollingSession.get(state.pollingSession);
export const getCarHire = (state: MichelinState) => fromCarHire.get(state.carhire);
export const getMichelinHotels = (state: MichelinState): MichelinHotelsState =>
  fromMichelinHotels.get(state.hotels);
export const getPackages = (state: MichelinState): PackagesState =>
  fromPackages.get(state.packages);
export const getPackagesRealTimeSavings = (state: MichelinState): PackagesRealTimeSavingsState =>
  fromPackagesRealTimeSavings.get(state.packagesRealTimeSavings);
export const getHotelIndicativePricing = (state: MichelinState): HotelIndicativePricingState =>
  fromHotelIndicativePricing.get(state.hotelIndicativePricing);
export const getCarHireIndicativePricing = (state: MichelinState): CarHireIndicativePricingState =>
  fromCarHireIndicativePricing.get(state.carHireIndicativePricing);
export const getExploreAccommodations = (state: MichelinState) =>
  fromExploreAccommodations.get(state.exploreAccommodations);
